module.exports = __webpack_public_path__ + "a7d8ba1065fb4484799c2366287c6602.png";